import type { MentionEntity } from '@terra/shared-dto-chat-types';
import type { ChatTabType } from './chatTabsStore';

const NON_PERSISTED_OBJECT_CONTEXT_KEYS = new Set(['fields', 'rawText']);

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function toPersistedMentionEntity(mentionEntity: MentionEntity): MentionEntity {
  const objectContext = mentionEntity.extraData?.objectContext;

  if (!isRecord(objectContext)) {
    return mentionEntity;
  }

  const objectReference = Object.fromEntries(
    Object.entries(objectContext).filter(
      ([key]) => !NON_PERSISTED_OBJECT_CONTEXT_KEYS.has(key),
    ),
  );

  return {
    ...mentionEntity,
    extraData: { ...mentionEntity.extraData, objectContext: objectReference },
  };
}

export function toPersistedChatTabMentions(
  mentions: ChatTabType['mentions'],
): ChatTabType['mentions'] {
  return mentions?.map((mention) =>
    mention.mentionEntity
      ? {
          ...mention,
          mentionEntity: toPersistedMentionEntity(mention.mentionEntity),
        }
      : mention,
  );
}
